import { ShieldCheck } from "lucide-react";

export const ApiSecurityTakeaway = () => {
  return (
    <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-transparent rounded-2xl border border-primary/20 p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center shrink-0">
          <ShieldCheck className="w-6 h-6 text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-2">Key Takeaway</h3>
          <p className="text-muted-foreground leading-relaxed">
            API security isn't optional — it's foundational. With 94% of applications having at least one 
            API vulnerability, implementing proper authentication, rate limiting, and input validation isn't 
            just best practice — it's essential for protecting your users and your business from increasingly 
            sophisticated attacks.
          </p>
        </div>
      </div>
    </div>
  );
};
